import {ErrorHandler, NgModule} from '@angular/core';
import {PlayerWebService} from './services/PlayerService/player.web.service';
import {CachingService} from './services/caching/caching.service';
import {SignagePlayerWeb} from './SignagePlayer/signage.player.web';
import {CommonModule} from '@angular/common';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {QRCodeModule} from "angularx-qrcode";
import {EventParams} from "./services/EventParams/event.params";
import {SignageLibsModuleCommon} from "./signage-libs.module.common";
import {GlobalErrorHandler} from "./services/GlobalErrorHandler";


@NgModule({
    declarations: [
      SignagePlayerWeb
    ],
    imports: [
      SignageLibsModuleCommon,
      CommonModule,
      BrowserAnimationsModule,
      QRCodeModule
    ],
    exports: [
      SignagePlayerWeb
    ],
    providers: [
      {
        provide: ErrorHandler, useClass: GlobalErrorHandler
      },
      {
        provide: 'cachingService',
        useClass: CachingService
      },
      {
        provide: 'playerService',
        useClass: PlayerWebService
      },
      {
        provide: 'eventParams',
        useClass: EventParams
      }
    ],
    bootstrap: []
})
export class SignageLibsModuleWeb { }
